exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map[data-v-02bb029b] {\n  width: 100%;\n  height: 50vh;\n}\n[data-v-02bb029b] .amap-marker-label {\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n}", ""]);

// exports
